import { z } from 'zod';

export const LogRetentionSchema = z.record(z.string(), z.number().int().nonnegative());

export const SettingsSchema = z
  .object({
    palette: z.string().optional(),
    typography: z.string().optional(),
    theme: z.enum(['dark', 'light']).optional(),
    currency: z.string().length(3).optional(),
    logRetention: LogRetentionSchema.optional(),
    logRetentionIntervalMinutes: z.number().int().positive().optional(),
  })
  .passthrough();

export const UpdateSettingsSchema = SettingsSchema.partial();

export type LogRetention = z.infer<typeof LogRetentionSchema>;
export type Settings = z.infer<typeof SettingsSchema>;
export type UpdateSettings = z.infer<typeof UpdateSettingsSchema>;
